import { Fancybox } from '@fancyapps/ui';

if (!customElements.get('fancybox-element')) {
  class FancyboxElement extends HTMLElement {
    constructor() {
      super();
      this.fancybox();
    }

    /*
     * Create fancybox
     */
    fancybox() {
      Fancybox.bind('[data-fancybox]', {
        animated: false,
        showClass: false,
        mainClass: 'fancybox__lightbox',
      });
    }
  }

  window.FancyboxElement = FancyboxElement;

  customElements.define('fancybox-element', FancyboxElement);
}
